import React from 'react';
import Spinner from '../../Libraries/Loader';

const Button = ({
    onClick,
    disabled,
    busy,
    children,
    small = false,
    medium = false,
    colour = 'black',
    type = 'button',
    className = '',
}) => {
    let classes = className;

    if (colour === 'black') {
        classes = classes + ' bg-grey-700 text-white md:hover:bg-green'
    }

    let sizes = small ? 'h-8 px-4 text-sm leading-8' : 'h-12 px-4 sm:px-10 leading-12'

    sizes = medium ? 'h-10 px-4 leading-6' : sizes;

    return <button type={ type } onClick={ onClick } disabled={ disabled } className={`${classes} rounded-sm w-full md:w-auto text-center inline-flex justify-center items-center relative ${sizes}`}>
        <span className={`${busy ? 'opacity-25' : ''}`}>
            { children }
        </span>

        { busy && <span className={'mt-0.5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform'}>
            <Spinner />
        </span>}
    </button>
};

export default Button;
